/** Kinmantle mark: twin peaks (the mantle) sheltering a small lantern flame. */
export function BrandMark({ size = "2.4rem" }: { size?: number | string }) {
  return (
    <svg className="brand-mark" width={size} height={size} viewBox="0 0 48 48" fill="none" aria-hidden="true">
      <path d="M4 34 L18 14 L25 23 L30 17 L44 34" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13 34 L18 27 L22 31" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" opacity="0.55" />
      <path d="M31 38c-2.3-1.1-3.4-3-3.4-4.8 0-2 1.4-3.6 3.4-5.8 2 2.2 3.4 3.8 3.4 5.8 0 1.8-1.1 3.7-3.4 4.8Z" fill="var(--accent)" />
    </svg>
  );
}

export function Wordmark({ compact }: { compact?: boolean }) {
  return (
    <div className={`wordmark ${compact ? "compact" : ""}`}>
      <BrandMark />
      {!compact && (
        <>
          <span className="wordmark-name">Kinmantle</span>
          <span className="wordmark-by">by Forge &amp; Lantern</span>
        </>
      )}
    </div>
  );
}
